import { Pagination, Text } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { formatDate, formatTime, getNotificationColor } from "./utilities";

import { useNavigate } from "react-router-dom";
import { getNotifications, makeseen } from "../apis/notificationapi";
import { getCookiesSession } from "../apis/cookiesSession";

const Notifications = () => {
  const navigate = useNavigate();
  const userData = JSON.parse(getCookiesSession("userData"));
  const filter = {
    role: userData.loginAs,
    department: userData.activeDepartment,
  };
  const [page, setPage] = useState(1);
  const [configs, setConfigs] = useState({
    loading: true,
    notifications: null,
    count: 0,
  });
  useEffect(() => {
    const getallNotifications = async () => {
      const resp = await getNotifications({ filter, page });
      setConfigs({
        loading: false,
        notifications: resp.notifications,
        count: resp.count,
      });
    };
    getallNotifications();
  }, [page]);
  const makeNotificationSeen = async (notificationId) => {
    const response = await makeseen({ notificationId });
  };
  console.log("configs, ", configs);
  function routeToObligation(id) {
    window.location.href = `/viewobligation/${id}`;
  }

  const cardStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "38px",
    padding: "0 12px",
    background: "#E8EBEB",
    border: "1px solid #077CA5",
    borderRadius: "8px",
    marginBottom: "6px",
    color: "#077CA5",
    cursor: "pointer"
  };
  
  return (
    <div className="px-4">
      <Text className="flex justify-center font-bold text-xl my-4">
        Alerts
      </Text>
      {!configs.loading &&
        configs.notifications &&
        configs.notifications.length > 0 && (
          <>
            {configs.notifications.map((notification) => (
              <div
                key={notification.id}
                onClick={async () => {
                  if (!notification.seen) {
                    await makeNotificationSeen(notification.id);
                  }
                  routeToObligation(notification.obligationId);
                }}
                style={{
                  ...cardStyle,
                  // Logic to change background if seen/unseen while keeping your border style
                  backgroundColor: notification.seen ? "#E8EBEB" : "#FFFFFF",
                }}
              >
                {/* Text Content */}
                <Text className="text-sm font-medium py-2">
                  {notification.notificationText}
                </Text>

                {/* Right Side: Date and Time */}
                <div className="flex items-center gap-4">
                  <div className="flex flex-row items-center" style={{ width: "90px" }}>
                    <img src="./assets/calender.svg" alt="calendar" className="w-4 h-4 mr-1" />
                    <Text size="xs">{formatDate(notification.createdAt)}</Text>
                  </div>
                  <div className="flex flex-row items-center" style={{ width: "70px" }}>
                    <img src="./assets/clock.svg" alt="clock" className="w-4 h-4 mr-1" />
                    <Text size="xs">{formatTime(notification.createdAt)}</Text>
                  </div>
                </div>
              </div>
            ))}

            <div className="flex flex-row justify-center my-4">
              <Pagination
                page={page}
                onChange={(p) => setPage(p)}
                total={Math.ceil(configs.count / 10)}
              />
            </div>
          </>
        )}

      {!configs.loading && configs.notifications?.length === 0 && (
        <Text className="text-center italic color-gray-500">no alerts for you...</Text>
      )}
    </div>
  );
};

export default Notifications;

